import { Box, Flex, Image, Navigation } from '@agrotoken-tech/ui';
import signUpImage from './assets/signup.jpg';
import { SignUpForm } from './forms/SignUpForm';
import { ExplorerLogo } from '@bcba/brand';
import { paths } from '../../routes/paths';

export const SignUp = () => (
  <Flex direction="column" h="100dvh">
    <Box minHeight="min-content">
      <Navigation
        homePath={paths.home}
        links={[]}
        mainButton={<ExplorerLogo />}
      />
    </Box>
    <Flex p={{ base: '8px', lg: '40px' }}>
      <Flex flex="0.5" h="765" display={{ base: 'none', lg: 'block' }}>
        <Image
          src={signUpImage}
          alt=""
          h="765"
          objectFit="cover"
          borderRadius={8}
        />
      </Flex>
      <Flex flex="1" h="full">
        <SignUpForm />
      </Flex>
    </Flex>
  </Flex>
);
